import React from 'react';
import DisintermediationModal from '../chat-disintermediation-modal';
import { FormattedMessage } from 'react-intl';
import { useStreamChatContext } from '../../utils/utils';
import PropTypes from 'prop-types';

export const ValidationWarnings = ({
  setShowContactInfoWarning,
  showContactInfoWarning,
  setShowDisintermediationModal,
  showDisintermediationModal
}) => {
  const {
    bookingId,
    ssoId
  } = useStreamChatContext();

  const handleDismissContactInfoWarning = () => {
    setShowContactInfoWarning(false);
    analytics.track('clicked_dismiss_from_phone_warning_notification', {
      bookingId,
      ssoId
    });
  };

  return (
    <div>
      {showContactInfoWarning && (
        <div className="bg-gray-200 warning-container">
          <p className="warning-text">
            <FormattedMessage id="inbox.contact_info_warning.message"
              defaultMessage="You may discuss plans by phone, but all bookings must be completed through Peerspace."/>
          </p>
          <p className="text-small dismiss-text" onClick={handleDismissContactInfoWarning}>
            <FormattedMessage className="dismiss-text text-small" id="inbox.contact_info_warning.dismiss"
              defaultMessage="Dismiss"/>
          </p>
        </div>
      )}
      {showDisintermediationModal
        && <DisintermediationModal
          toggleModal={() => setShowDisintermediationModal(false)}
          showModal={showDisintermediationModal}
        />
      }
    </div>
  );
};

ValidationWarnings.propTypes = {
  setShowContactInfoWarning: PropTypes.func,
  showContactInfoWarning: PropTypes.bool,
  setShowDisintermediationModal: PropTypes.func,
  showDisintermediationModal: PropTypes.bool
};
